const haveInternetAccess = async (): Promise<boolean> => {
	return haveInternetAccessByNavigator();
};

const haveInternetAccessByNavigator = () => {
	if (typeof window === "undefined") return true;
	return window.navigator?.onLine ?? true;
};

export default haveInternetAccess;
